<script lang="ts">
	import { getLocale } from '$lib/paraglide/runtime';
	import type { buildSeoMeta } from '$lib/seo';

	type SeoProps = ReturnType<typeof buildSeoMeta>;
	let { seo }: { seo: SeoProps } = $props();
</script>

<svelte:head>
	<title>{seo.title}</title>
	<meta name="description" content={seo.description} />
	<link rel="canonical" href={seo.url} />

	<!-- Open Graph — dérivé des champs de base -->
	<meta property="og:title" content={seo.title} />
	<meta property="og:description" content={seo.description} />
	<meta property="og:url" content={seo.url} />
	<meta property="og:image" content={seo.image} />
	<meta property="og:image:width" content="1200" />
	<meta property="og:image:height" content="630" />
	<meta property="og:image:alt" content={seo.imageAlt} />
	<meta property="og:type" content={seo.type} />
	<meta property="og:site_name" content="juslin.dev" />
	<meta property="og:locale" content={getLocale()} />

	<!-- Twitter / X — dérivé des mêmes champs -->
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:title" content={seo.title} />
	<meta name="twitter:description" content={seo.description} />
	<meta name="twitter:image" content={seo.image} />
	<meta name="twitter:creator" content={seo.twitterCreator} />
</svelte:head>
